<template lang="pug">
form(@submit.prevent="onSubmit")
  modal(
      active
      :title='$route.params.id ? "Editar registro de ausencia" : "Novo registro de ausência"'
      @close="$router.back()"
    )
    div(slot='modal-body')
      .columns
        .column.col-12
          form-group(:label="'ausente.ausente' | tModel" :validation="$v.form.ausente_id")
            fiscal-picker(v-model="$v.form.ausente_id.$model")
        .column.col-12
          form-group(:label="'ausente.substituto' | tModel" :validation="$v.form.substituto_id")
            fiscal-picker(v-model="$v.form.substituto_id.$model")
        .column.col-12
          form-group(:label="'ausente.tipo' | tModel" :validation="$v.form.tipo")
            select.form-select(v-model="$v.form.tipo.$model")
              option
              option(v-for="label, key in tipos" :value="key") {{ label }}
        .column.col-6.col-md-12
          form-group(:label="'ausente.inicia_em' | tModel" :validation="$v.form.inicia_em")
            datepicker(v-model="$v.form.inicia_em.$model")
        .column.col-6.col-md-12
          form-group(:label="'ausente.termina_em' | tModel" :validation="$v.form.termina_em")
            datepicker(v-model="$v.form.termina_em.$model")
    div(slot='modal-footer')
      button.btn.btn-primary(:disabled="$v.form.$invalid")
        btn-content(name="save")
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'
import { required } from 'vuelidate/lib/validators'
export default {
  vuex: {
    'sistema/ausentes': {
      actions: ['fetchCreate', 'fetchUpdate', 'fetchOne'],
    },
  },
  computed: {
    tipos() {
      return this.$i18n.t('enums.db.enum_ausente_tipo')
    },
  },
  data() {
    return {
      form: {
        id: null,
        ausente_id: null,
        substituto_id: null,
        tipo: null,
        inicia_em: null,
        termina_em: null,
      },
    }
  },
  validations: {
    form: {
      id: {},
      ausente_id: { required },
      substituto_id: { required },
      tipo: { required },
      inicia_em: { required },
      termina_em: { required },
    },
  },
  methods: {
    async onSubmit() {
      try {
        if (this.$route.params.id) {
          await this.fetchUpdate(this.form)
        } else {
          await this.fetchCreate(this.form)
        }
        this.$toaster.success('Registro de ausência salvo')
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      }
    },
  },
  async created() {
    if (this.$route.params.id) {
      const data = await this.fetchOne(this.$route.params.id)
      this.form = { ...data }
    }
  },
}
</script>
